/**
 * External Supabase project configuration.
 * ALL backend services (DB, Auth, Edge Functions) run on this project.
 */
const PRODUCTION_PROJECT_REF = "frdavdgxshhfugzokkmm";

// Overridable per-environment via VITE_SUPABASE_URL (e.g. a Vercel preview pointed at a
// Supabase preview branch). Falls back to production when the env var is absent.
export const EXTERNAL_SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL || `https://${PRODUCTION_PROJECT_REF}.supabase.co`;
export const EXTERNAL_FUNCTIONS_URL = `${EXTERNAL_SUPABASE_URL}/functions/v1`;

export const authStorageKeyFor = (url: string): string => {
  try {
    const { hostname } = new URL(url);
    if (hostname.endsWith(".supabase.co")) return `sb-${hostname.split(".")[0]}-auth-token`;
  } catch {}
  return `sb-${PRODUCTION_PROJECT_REF}-auth-token`;
};

export const EXTERNAL_SUPABASE_AUTH_STORAGE_KEY = authStorageKeyFor(EXTERNAL_SUPABASE_URL);

// Publishable (anon) key — safe in client-side code. Overridable via VITE_SUPABASE_PUBLISHABLE_KEY.
export const EXTERNAL_SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "sb_publishable_pJDKJb4Hk3TB8zVuP_uMZg_Trj65DUp";
